import { gql } from '@apollo/client';

export const getYearMachineUtilisation = gql`
  query getYearMachineUtilisation($isoYear: Int!) {
    getYearMachineUtilisation(isoYear: $isoYear) {
      name
      isoYear
      isoMonth
      cleanedSquareMeter
      hours
    }
  }
`;

export const getMonthMachineUtilisation = gql`
  query getMonthMachineUtilisation($isoMonth: Int!, $isoYear: Int!) {
    getMonthMachineUtilisation(isoMonth: $isoMonth, isoYear: $isoYear) {
      name
      isoYear
      isoMonth
      isoWeek
      startDateOfWeek
      endDateOfWeek
      cleanedSquareMeter
      hours
    }
  }
`;

export const getWeekMachineUtilisation = gql`
  query getWeekMachineUtilisation($isoWeek: Int!, $isoYear: Int!) {
    getWeekMachineUtilisation(isoWeek: $isoWeek, isoYear: $isoYear) {
      name
      isoYear
      isoWeek
      isoDay
      cleanedSquareMeter
      hours
    }
  }
`;
